import { Component } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import { SplashService } from './Services/splash.service';
import { HelperService } from './Services/helper.service';
import { Inject,Injectable,PLATFORM_ID } from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import { platformBrowser } from '@angular/platform-browser';
import { TranslationService } from './Services/translation.service';
import {Local} from "protractor/built/driverProviders";
import {LocalStorageService} from "./Services/local-storage.service";
import {CITY} from "./tokens";

registerSwiperElements();

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'zavedenia';
  city: string;
  insidePageCheck: boolean = false;
  constructor(
    public router: Router,
    private splashScreen: SplashService,
    private helperService: HelperService,
    private translationService: TranslationService,
    private localStorage: LocalStorageService,
    @Inject(DOCUMENT) private document,
    @Inject(CITY) private injectedCity: string,
    @Inject(PLATFORM_ID) private platformId) {

      this.city = this.injectedCity || this.helperService.getCity();
      this.localStorage.setItem('city', JSON.stringify(this.city));
      if(this.city == 'skopje'){
          this.translationService.setLanguage('mk');
      }
      if(this.city == 'beograd'){
          this.translationService.setLanguage('sr');
      }
      this.router.events.subscribe((event: Event) => {
          if (event instanceof NavigationEnd) {
            this.insidePageCheck = (this.router.url != '/' && this.router.url != '/en');
            // if(!platformBrowser(platformId)){
            //   window.gtag('set', 'page', event.urlAfterRedirects);
            //   gtag('send', 'pageview');
            // }
        }
      });

    }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.splashScreen.stop();
    this.city = this.injectedCity || this.helperService.getCity();
  }
  ngOnDestroy(){
    this.router
  }
}
